<template>
<div class="data-table" >
  <div class="wrapper" >
    <el-table
      ref="table"
      :data="normalizedData"
      :border="true"
      :row-class-name="({row}) => selectableClassStr(row)"
      @row-click="handleSelect" >
      <el-table-column prop="data.Group0Caption" :label="dimensionColumnTitle" :sortable="true" />
      <el-table-column
         v-for="(measure, i) in measures"
         :key="api.measure.name(measure)"
         :prop="'data.measure_' + i"
         :label="translate(api.measure.name(measure))"
         :sortable="true" >
        <template slot-scope="{row}" >
          <template v-if="row.data[api.measure.name(measure)] !== 'N/A'" >
            {{ formatters[api.measure.uniqueName(measure)](row.data[api.measure.name(measure)]) }}
          </template>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(property, i) in properties"
        :key="property.uniqueName"
        :prop="'data.property_' + i"
        :label="property.name"
        :sortable="true" />
    </el-table>
    </div>
  </div>
</template>

<script>
import selectable from 'd3vue/mixins/selectable.js'
import { trans } from './dataFilter'
import customGraphApiAware from './mixins/customGraphApiAware'

export default {
  mixins: [
    selectable,
    customGraphApiAware
  ],
  props: {
    formatters: {
      Object,
      required: true
    },
    data: {
      required: true,
      type: Array
    },
    measures: {
      required: true,
      type: Array
    },
    dimensionColumnTitle: {
      required: false,
      type: String
    },
    defaultSort: {
      type: [Object, null],
      default: null
    },
    properties: {
      type: [Array, null],
      default () {
        return []
      }
    },
    trans: {
      type: [Object, null],
      default: null
    }
  },
  data () {
    return {
      timeout: null
    }
  },
  computed: {
    normalizedData () {
      return this.data.map(d => {
        const result = { data: Object.assign({}, d.data) }
        this.measures.forEach((measure, i) => {
          result.data['measure_' + i] = d.data[this.api.measure.name(measure)]
        })
        this.properties.forEach((property, i) => {
          result.data['property_' + i] = d.data[`Group0Prop${property.name}`]
        })
        return result
      })
    }
  },
  watch: {
    defaultSort: {
      immediate: true,
      handler (sort) {
        this.sort(sort)
      }
    }
  },
  methods: {
    translate (str) {
      return trans(str, this.trans)
    },
    sort (sort) {
      if (!sort) {
        return
      }
      if (!this.$refs.table) {
        this.timeout = setTimeout(() => this.sort(sort), 500)
      }
      else {
        this.$refs.table.sort(sort.prop, sort.order)
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
  }
}
</script>

<style scoped>
.data-table {
    overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px;
}
.wrapper {
    position: relative;
}
.data-table >>> table {
    border: collapse;
    margin-bottom: 2px;
}
.data-table >>> tr.selected td {
    border-top: 1px solid red;
    border-bottom: 1px solid red;
    border-right: 1px solid red;
    position: relative;
}
.data-table >>> tr.selected td::before {
    content: "";
    width: 1px;
    height: 100%;
    display: block;
    background-color: white;
    position: absolute;
    z-index: 1;
    top: 0;
    left: -1px;
}
.data-table >>> tr.selected td:first-child {
    border-left: 1px solid red;
}
.data-table >>> tr.selected td:first-child::before {
    display: none;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/DataTable.vue